import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import renderTemplate from 'lodash.template';

import DEFAULTS from './constants';
import { InvalidResponseCode, NetworkError, RequestValidationError } from './errors';
import { isFunction, isObject, hasValue } from './typeChecks';
import { mergeConfig, serializeCookies } from './util';

var GenericResource = function () {
    /**
     * @param apiEndpoint Endpoint used for this resource. Supports ES6 token syntax, e.g: "/foo/bar/${pk}"
     * @param config Customize config for this resource (see `Router.config`)
     */
    function GenericResource(apiEndpoint, config) {
        _classCallCheck(this, GenericResource);

        this.apiEndpoint = apiEndpoint;

        // Set config
        this._customConfig = config;

        // set parent to null
        this._parent = null;
    }

    _createClass(GenericResource, [{
        key: '_setParent',
        value: function _setParent(parent) {
            this._parent = parent;
        }
    }, {
        key: 'mutateRawResponse',
        value: function mutateRawResponse(rawResponse) {
            if (isFunction(this.config.mutateRawResponse)) {
                return this.config.mutateRawResponse(rawResponse);
            }

            return rawResponse;
        }
    }, {
        key: 'mutateResponse',
        value: function mutateResponse(responseData, rawResponse) {
            if (isFunction(this.config.mutateResponse)) {
                return this.config.mutateResponse(responseData, rawResponse, this);
            }

            return responseData;
        }
    }, {
        key: 'mutateError',
        value: function mutateError(error, rawResponse) {
            if (isFunction(this.config.mutateError)) {
                return this.config.mutateError(error, rawResponse, this);
            }

            return error;
        }
    }, {
        key: 'getHeaders',
        value: function getHeaders() {
            var headers = _extends({}, this.parent ? this.parent.getHeaders() : {}, (isFunction(this.config.headers) ? this.config.headers() : this.config.headers) || {});

            var cookieVal = serializeCookies(this.getCookies());
            if (cookieVal) {
                headers.Cookie = cookieVal;
            }

            // if Accept is null/undefined, add default accept header automatically (backwards incompatible for text/html)
            if (!hasValue(headers.Accept)) {
                headers.Accept = this.config.defaultAcceptHeader;
            }

            return headers;
        }
    }, {
        key: 'getCookies',
        value: function getCookies() {
            return _extends({}, this.parent ? this.parent.getCookies() : {}, (isFunction(this.config.cookies) ? this.config.cookies() : this.config.cookies) || {});
        }
    }, {
        key: 'handleRequest',
        value: function handleRequest(req) {
            var _this = this;

            return this.ensureStatusAndJson(new _Promise(function (resolve) {
                var headers = _this.getHeaders();

                if (headers && isObject(headers)) {
                    _Object$keys(headers).forEach(function (key) {
                        if (hasValue(headers[key])) {
                            req = _this.setHeader(req, key, headers[key]);
                        }
                    });
                }

                _this.doRequest(req, function (response, error) {
                    return resolve(_this.constructor.wrapResponse(response, error, req));
                });
            }));
        }
    }, {
        key: 'ensureStatusAndJson',
        value: function ensureStatusAndJson(prom) {
            var _this2 = this;

            return prom.then(function (origRes) {
                var res = _this2.mutateRawResponse(origRes);

                // If no error occured
                if (res && !res.hasError) {
                    if (_this2.config.statusSuccess.indexOf(res.status) !== -1) {
                        // Got statusSuccess response code, lets resolve this promise
                        return _this2.mutateResponse(res.data, res);
                    } else if (_this2.config.statusValidationError.indexOf(res.status) !== -1) {
                        // Got statusValidationError response code, lets throw RequestValidationError
                        throw _this2.mutateError(new RequestValidationError(res.status, res.text, _this2.config), res);
                    } else {
                        // Throw a InvalidResponseCode error
                        throw _this2.mutateError(new InvalidResponseCode(res.status, res.text), res);
                    }
                } else {
                    // res.hasError should only be true if network level errors occur (not statuscode errors)
                    var message = res && res.hasError ? res.error : '';

                    throw _this2.mutateError(new NetworkError(message || 'Something went awfully wrong with the request, check network log.'), res);
                }
            });
        }
    }, {
        key: 'buildThePath',
        value: function buildThePath(urlParams) {
            var thePath = this.apiEndpoint;

            if (urlParams && !(isObject(urlParams) && _Object$keys(urlParams).length === 0)) {
                thePath = renderTemplate(this.apiEndpoint)(urlParams);
            }

            return '' + this.config.apiRoot + thePath;
        }

        /* istanbul ignore next */

    }, {
        key: 'createRequest',


        /* istanbul ignore next */
        value: function createRequest(method, url, query, data) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }
    }, {
        key: 'parent',
        get: function get() {
            return this._parent;
        }
    }, {
        key: 'isBound',
        get: function get() {
            return !!this._parent || !!this._config;
        }
    }, {
        key: 'config',
        get: function get() {
            if (!this._config) {
                this._config = mergeConfig(this.parent ? this.parent.config : DEFAULTS, this._customConfig);
            }

            return this._config;
        }
    }], [{
        key: 'wrapResponse',
        value: function wrapResponse(res, error, req) {
            // eslint-disable-line no-unused-vars
            throw new Error('Not implemented');
        }
    }]);

    return GenericResource;
}();

export default GenericResource;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/base.js
// module id = 1145
// module chunks = 0